export default "__VITE_ASSET__1e920880__"